module.exports = __webpack_public_path__ + "static/img/周少文A.cb75ce23.png";